module.exports = __webpack_public_path__ + "static/img/home_img3@2x(2).a9987653.png";